import { ProfileInterface } from '@/shared/interfaces/profile.interface';
import { Employee } from '@/shared/models/employee.model';

export interface UserInterface {
    id?: string;
    username: string;
    firstName: string;
    lastName: string;
    secondLastName?: string;
    email: string;
    profile: ProfileInterface;
    employee: Employee;
    isActive: boolean;
}

export class User implements UserInterface {
    public id?: string;
    public username: string;
    public firstName: string;
    public lastName: string;
    public secondLastName?: string;
    public email: string;
    public profile: ProfileInterface;
    public employee: Employee;
    public isActive: boolean;

    constructor() {
        this.username = '';
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.profile = {};
        this.employee = {};
        this.isActive = true;
    }
}
